// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__33LMc","row":"ProcedureTreatmentSummary_row__2uh9K"};